module.exports = __webpack_public_path__ + "static/future-of-work-flex-is-best-9f35acd975d42c40a05af32c336d42dd.png";